/**
 * Remembers a person who has already given us their details for a free
 * resource, so we never ask twice, and keeps their taster answers until
 * they create an account.
 */

const KEY = "wekit.freequiz.v1";

export interface FreeQuizLead {
  name: string;
  email: string;
  mobile?: string | null;
  ageBand?: string | null;
  magnet: string;
  answers?: Record<string, string>;
  primary?: string | null;
  secondary?: string | null;
  at: string;
}

export function saveFreeQuizLead(lead: Omit<FreeQuizLead, "at">) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...lead, at: new Date().toISOString() }));
  } catch {
    /* storage may be unavailable — never break the flow */
  }
}

export function readFreeQuizLead(): FreeQuizLead | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as FreeQuizLead;
    if (!parsed?.email || !parsed?.name) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearFreeQuizLead() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* nothing to do */
  }
}
